"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PT__GQ = 'goalquest';
exports.PT__CP = 'challengepoint';
exports.PT__OBJ = 'objective';
exports.programTypes = {
    PT__GQ: exports.PT__GQ,
    PT__CP: exports.PT__CP,
    PT__OBJ: exports.PT__OBJ
};
exports.TT__OVERVIEW = 'overview';
exports.TT__GOAL_SELECTION = 'goal-selection';
exports.TT__NO_GOAL_SELECTED = 'no-goal-selected';
exports.TT__NO_PROGRESS = 'no-progress';
exports.TT__PROGRESS = 'progress';
exports.TT__PROGRESS_AVGERAGE = 'progress-average';
exports.TT__WAITING_FOR_PROGRESS = 'waiting-for-progress';
exports.TT__FINAL_RESULT = 'final-result';
exports.tileTypes = {
    TT__OVERVIEW: exports.TT__OVERVIEW,
    TT__NO_GOAL_SELECTED: exports.TT__NO_GOAL_SELECTED,
    TT__GOAL_SELECTION: exports.TT__GOAL_SELECTION,
    TT__NO_PROGRESS: exports.TT__NO_PROGRESS,
    TT__PROGRESS: exports.TT__PROGRESS,
    TT__PROGRESS_AVGERAGE: exports.TT__PROGRESS_AVGERAGE,
    TT__FINAL_RESULT: exports.TT__FINAL_RESULT
};
exports.PVS__GOAL_SELECTION = 'goal_selection';
exports.PVS__GOAL_SELECTED = 'goal_selected';
exports.PVS__NO_GOAL_SELECTED = 'no_goal_selected';
exports.PVS__NO_PROGRESS = 'no_progress';
exports.PVS__PROGRESS_LOADED_NO_ISSUANCE = 'progress_loaded_no_issuance';
exports.PVS__FINAL_ISSUANCE = 'final_issuance';
exports.programViewStatus = {
    PVS__GOAL_SELECTION: exports.PVS__GOAL_SELECTION,
    PVS__GOAL_SELECTED: exports.PVS__GOAL_SELECTED,
    PVS__NO_GOAL_SELECTED: exports.PVS__NO_GOAL_SELECTED,
    PVS__NO_PROGRESS: exports.PVS__NO_PROGRESS,
    PVS__PROGRESS_LOADED_NO_ISSUANCE: exports.PVS__PROGRESS_LOADED_NO_ISSUANCE,
    PVS__FINAL_ISSUANCE: exports.PVS__FINAL_ISSUANCE
};
exports.PVS__STATE_ORDER = [
    exports.PVS__GOAL_SELECTION,
    exports.PVS__GOAL_SELECTED,
    exports.PVS__NO_GOAL_SELECTED,
    exports.PVS__NO_PROGRESS,
    exports.PVS__PROGRESS_LOADED_NO_ISSUANCE,
    exports.PVS__FINAL_ISSUANCE
];
exports.ROLE__SELECTOR = 'Selector';
exports.ROLE__MANAGER = 'Manager';
exports.ROLE__MULTIMANAGER = 'multimanager';
exports.ROLE__OWNER = 'Owner';
exports.ROLE__MULTIOWNER = 'multiowner';
exports.ROLE__PARTNER = 'Partner';
exports.ROLE__SUPERVIEWER = 'Superviewer';
exports.role = {
    ROLE__SELECTOR: exports.ROLE__SELECTOR,
    ROLE__MANAGER: exports.ROLE__MANAGER,
    ROLE__MULTIMANAGER: exports.ROLE__MULTIMANAGER,
    ROLE__OWNER: exports.ROLE__OWNER,
    ROLE__MULTIOWNER: exports.ROLE__MULTIOWNER,
    ROLE__PARTNER: exports.ROLE__PARTNER,
    ROLE__SUPERVIEWER: exports.ROLE__SUPERVIEWER
};
// Achievement Rule Types
exports.AR__FIXED = 'fixed_amount';
exports.AR__PCT_OF_BASELINE = 'percentage_of_baseline';
exports.AR__BASELINE_PLUS_FIXED = 'baseline_plus_fixed_amount';
exports.AR__GOAL_SELECTED = 'goal_selected';
exports.AR__PCT_OF_THRESHOLD = 'percentage_of_threshold';
exports.achievementRule = {
    AR__FIXED: exports.AR__FIXED,
    AR__PCT_OF_BASELINE: exports.AR__PCT_OF_BASELINE,
    AR__BASELINE_PLUS_FIXED: exports.AR__BASELINE_PLUS_FIXED,
    AR__GOAL_SELECTED: exports.AR__GOAL_SELECTED,
    AR__PCT_OF_THRESHOLD: exports.AR__PCT_OF_THRESHOLD
};
exports.PAYOUT__AT_PROGRESS = 'pay_at_progress';
exports.PAYOUT__AT_END = 'pay_at_end_of_program';
exports.payout = {
    PAYOUT__AT_PROGRESS: exports.PAYOUT__AT_PROGRESS,
    PAYOUT__AT_END: exports.PAYOUT__AT_END
};
exports.PT__FIXED = 'fixed';
exports.PT__RATE = 'rate';
exports.PT__FIXED_RATE = 'fixed+rate';
exports.payoutType = {
    PT__FIXED: exports.PT__FIXED,
    PT__RATE: exports.PT__RATE,
    PT__FIXED_RATE: exports.PT__FIXED_RATE
};
// Calculation Types
exports.CALC_AVERAGE = 'average';
exports.CALC_STANDARD = 'standard';
exports.CALC_REDUCTION = 'reduction';
// Manager Override Types
exports.MO__PCT_OF_OVERRIDE = 'percentage_of_override';
exports.MO__FLAT_PAYOUT = 'flat_payout';
exports.MO__PCT_OF_TEAM_ACHIEVEMENT = 'percentage_of_team_achievement_tiers';
exports.MO__NO_OVERRIDE = 'no_manager_override';
exports.managerOverride = {
    MO__PCT_OF_OVERRIDE: exports.MO__PCT_OF_OVERRIDE,
    MO__FLAT_PAYOUT: exports.MO__FLAT_PAYOUT,
    MO__PCT_OF_TEAM_ACHIEVEMENT: exports.MO__PCT_OF_TEAM_ACHIEVEMENT,
    MO__NO_OVERRIDE: exports.MO__NO_OVERRIDE
};
// SSO Types
exports.SSO__NONE = 'login_only';
exports.SSO__LOGIN = 'sso_login';
exports.SSO__ONLY = 'sso_only';
exports.ssoType = {
    SSO__NONE: exports.SSO__NONE,
    SSO__LOGIN: exports.SSO__LOGIN,
    SSO__ONLY: exports.SSO__ONLY
};
exports.authType = {
    LOGIN: 'login',
    SSO: 'sso'
};
exports.default = {
    programViewStatus: exports.programViewStatus,
    role: exports.role,
    achievementRule: exports.achievementRule,
    payout: exports.payout,
    managerOverride: exports.managerOverride,
    ssoType: exports.ssoType,
    authType: exports.authType
};
const dashboardCommon = 'dashboard.tile.common.';
exports.KEY_CODES = {
    achieveyourGoalEarnRewards: `${dashboardCommon}achieveyourGoalEarnRewards`,
    by: `${dashboardCommon}by`,
    changegoal: `${dashboardCommon}changegoal`,
    checkingResults: `${dashboardCommon}checkingResults`,
    closes: `${dashboardCommon}closes`,
    daylefttoselectgoal: `${dashboardCommon}daylefttoselectgoal`,
    days: `${dashboardCommon}days`,
    day: `${dashboardCommon}day`,
    dayslefttochangegoal: `${dashboardCommon}dayslefttochangegoal`,
    dayslefttoearn: `${dashboardCommon}dayslefttoearn`,
    finalResults: `${dashboardCommon}finalResults`,
    goalrightforyou: `${dashboardCommon}goalrightforyou`,
    lastday: `${dashboardCommon}lastday`,
    mustselectgoal: `${dashboardCommon}mustselectgoal`,
    onyourmark: `${dashboardCommon}onyourmark`,
    opencatalog: `${dashboardCommon}opencatalog`,
    programHasEnded: `${dashboardCommon}programHasEnded`,
    progressAsOf: `${dashboardCommon}progressAsOf`,
    pushyourself: `${dashboardCommon}pushyourself`,
    waytopush: `${dashboardCommon}waytopush`,
    redeemaward: `${dashboardCommon}redeemaward`,
    redeembonus: `${dashboardCommon}redeembonus`,
    seeResults: `${dashboardCommon}seeResults`,
    seeprogress: `${dashboardCommon}seeprogress`,
    selectagoal: `${dashboardCommon}selectagoal`,
    selectedGoal: `${dashboardCommon}selectedGoal`,
    setyourplan: `${dashboardCommon}setyourplan`,
    sorry: `${dashboardCommon}sorry`,
    sorryellip: `${dashboardCommon}sorryellip`,
    starts: `${dashboardCommon}starts`,
    togoal: `${dashboardCommon}togoal`,
    updated: `${dashboardCommon}updated`,
    upforchallenge: `${dashboardCommon}upforchallenge`,
    viewDetails: `${dashboardCommon}viewDetails`,
    waitingForFinal: `${dashboardCommon}waitingForFinal`,
    youearned: `${dashboardCommon}youearned`,
    youearneda: `${dashboardCommon}youearneda`,
    youselect: `${dashboardCommon}youselect`,
    //Objectives
    untilProgramStarts: `${dashboardCommon}untilProgramStarts`,
    learnAboutProgram: `${dashboardCommon}learnAboutProgram`,
    getReady: `${dashboardCommon}getReady`,
    checkoutYourTeamsGoals: `${dashboardCommon}checkoutYourTeamsGoals`,
    waitingForProgress: `${dashboardCommon}waitingForProgress`,
    //Manager
    leftToChangeGoal: 'dashboard.tile.manager.leftToChangeGoal',
    getEveryoneToSelect: 'dashboard.tile.manager.getEveryoneToSelect',
    leftToEarn: 'dashboard.tile.manager.leftToEarn',
    timeToMotivate: 'dashboard.tile.manager.timeToMotivate',
    participantsOnTrack: 'dashboard.tile.manager.participantsOnTrack',
    participantsAchieved: 'dashboard.tile.manager.participantsAchieved' // Participants Achieved
};
//# sourceMappingURL=index.js.map